import {Map, List} from 'immutable';

import {
  REGISTRATION_LIST_REQUEST,
  REGISTRATION_LIST_SUCCESS,
  REGISTRATION_LIST_FAILURE,
  REGISTRATION_READ_REQUEST,
  REGISTRATION_READ_SUCCESS,
  REGISTRATION_READ_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function registration(
  state=Map({
    isLoading: false,
    pages: {}
  }),
  action
) {
  Logger.log('debug', `[registration.reducers] registration(%j, %j)`, state, action);

  switch(action.type) {

    case REGISTRATION_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case REGISTRATION_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case REGISTRATION_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case REGISTRATION_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case REGISTRATION_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case REGISTRATION_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });
      
    default:
      return state;
  }
}

Logger.log('silly', `registration.reducers loaded.`);
